import { Grid } from "@material-ui/core";
import * as React from "react";
import VisualiserFonctionnalite from "../VisualiserFonctionnalite";
import Fonctionnalite from "./Fonctionnalite";
import GroupeFonctionnalite from "./GroupeFonctionnalite";
import Module from "./Module";
import SousModule from "./SousModule";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import {
  setFilterFonctionnalites,
  setFonctionnalites,
} from "./Fonctionnalite/fonctionnaliteSlice";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const GestionFonctionnalite = () => {
  //redux
  const dispatch = useDispatch();
  const { fonctionnalites } = useSelector(
    (state: IReduxState) => state.fonctionnalite
  );

  //hooks
  const [creer, setCreer] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const theme = useTheme();
  const modeEcran = useMediaQuery(theme.breakpoints.down("lg"));

  const filterFonctionnalites = () => {
    if (search.length === 0) {
      dispatch(setFilterFonctionnalites([...fonctionnalites]));
    } else {
      const result: any = fonctionnalites.filter((item, index) => {
        const value: any = `${item.libelleFonctionnalite} ${item.descriptionFonctionnalite} ${item.idFonctionnalite}`;
        return value.toLowerCase().includes(search.toLowerCase());
      });
      dispatch(setFilterFonctionnalites(result));
    }
  };

  React.useEffect(() => {
    filterFonctionnalites();
  }, [search]);

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="center"
        spacing={2}
        style={{
          background: "aliceblue",
          marginBottom: 10,
          height: "9vh",
          padding: 10,
        }}
      >
        <Grid item xs={12} md={6}>
          <Button
            startIcon={<AddIcon />}
            variant={creer ? "contained" : "outlined"}
            onClick={() => setCreer(true)}
            style={{ marginRight: 5 }}
          >
            Créer
          </Button>

          <Button
            startIcon={<VisibilityIcon />}
            variant={!creer ? "contained" : "outlined"}
            onClick={() => setCreer(false)}
          >
            Visualiser
          </Button>
        </Grid>

        <Grid item xs={12} md={6}>
          {!creer && (
            <TextField
              style={{ marginTop: modeEcran ? 15 : 0 }}
              size="small"
              fullWidth
              label="Rechercher..."
              onChange={(e) => setSearch(e.target.value)}
            />
          )}
        </Grid>
      </Grid>

      {creer ? (
        <Grid 
        container
         spacing={3}
         style={{
          height: "55vh",
          overflow: "auto"
         }}
         >
          <Grid item xs={12} md={3}>
            <Module />
          </Grid>
          <Grid item xs={12} md={3}>
            <SousModule />
          </Grid>
          <Grid item xs={12} md={3}>
            <GroupeFonctionnalite />
          </Grid>
          <Grid item xs={12} md={3}>
            <Fonctionnalite />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <VisualiserFonctionnalite />
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default GestionFonctionnalite;
